import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { MatDialogModule, MatSnackBarModule } from '@angular/material';
import { AiDynamicMatDialog } from './dynamic-dialog';
import { AiDynamicOverlay } from './dynamic-overlay';
import { AiDynamicOverlayContainer } from './dynamic-overlay-container';
import { AiDynamicMatSnackBar } from './dynamic-snack-bar';

// Inject these providers at the component level
// to get a fresh instance of AiDynamicMatDialog service with it's own
// instances of AiDynamicOverlay/AiDynamicOverlayContainer.
//
// This enables to set the overlay container element dynamically
// and separates it from any other MatDialog/Overlay/OverlayContainer instances.

export const DYNAMIC_OVERLAY_PROVIDERS = [
  AiDynamicOverlayContainer,
  AiDynamicOverlay,
  AiDynamicMatDialog,
  AiDynamicMatSnackBar
];

@NgModule({
  imports: [
    OverlayModule,
    MatDialogModule,
    MatSnackBarModule,
  ],
  providers: DYNAMIC_OVERLAY_PROVIDERS
})
export class AiDynamicOverlayModule {
}
